import DraftBaseController from 'cio/pods/draft/base-controller';

export default class EditController extends DraftBaseController {
  get draft() {
    return this.model.belongsTo('detail').value();
  }
}
